import React from 'react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-8 border-b pb-4">Impressum</h1>
          
          <div className="space-y-10">
            {/* Betreiber der Website */}
            <section>
              <h2 className="text-xl font-bold text-blue-700 mb-4 uppercase tracking-wide">Angaben gemäß § 5 TMG</h2>
              <div className="text-lg text-gray-700 leading-relaxed bg-gray-50 p-6 rounded-lg border-l-4 border-blue-600">
                <p className="font-bold">Kai Alexander Bewig</p>
                <p>Schimmelstraße 6</p>
                <p>89415 Lauingen</p>
              </div>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-xl font-bold text-blue-700 mb-4 uppercase tracking-wide">Kontakt</h2>
              <div className="text-lg text-gray-700 leading-relaxed bg-gray-50 p-6 rounded-lg border-l-4 border-yellow-400">
                <p className="flex flex-col sm:flex-row sm:gap-2">
                  <span className="font-semibold">E-Mail:</span>
                  <a href="mailto:kai@bewig.de" className="text-blue-600 hover:underline">kai@bewig.de</a>
                </p>
                <p className="flex flex-col sm:flex-row sm:gap-2 mt-2">
                  <span className="font-semibold">Telefon:</span>
                  <a href="tel:09072-718110" className="text-blue-600 hover:underline">09072-718110</a>
                </p>
              </div>
            </section>

            {/* Verantwortlichkeit */}
            <section>
              <h2 className="text-xl font-bold text-blue-700 mb-4 uppercase tracking-wide">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <div className="text-lg text-gray-700 leading-relaxed bg-gray-50 p-6 rounded-lg border-l-4 border-blue-600">
                <p className="font-bold">Kai Alexander Bewig</p>
                <p>Schimmelstraße 6</p>
                <p>89415 Lauingen</p>
              </div>
            </section>

            {/* Disclaimer */}
            <section className="pt-6 border-t border-gray-100">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Rechtliche Hinweise</h2>
              <div className="space-y-4 text-gray-600 text-sm leading-relaxed">
                <div>
                  <h3 className="font-bold text-gray-700">Haftung für Inhalte</h3>
                  <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                </div>
                <div>
                  <h3 className="font-bold text-gray-700">Haftung für Links</h3>
                  <p>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                </div>
                <div>
                  <h3 className="font-bold text-gray-700">Urheberrecht</h3>
                  <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;